import {
  ChangeEvent,
  Dispatch,
  SetStateAction,
  useEffect,
  useState,
} from 'react';
import {
  AdditionalSendPedigreeData,
  sendPedigreeFinalReviewData,
} from './SendPedigree';

interface IProps {
  setAdditionalData: Dispatch<
    SetStateAction<AdditionalSendPedigreeData | undefined>
  >;
  setFinalReviewData: Dispatch<SetStateAction<sendPedigreeFinalReviewData>>;
}

const AdditionalData = ({ setAdditionalData, setFinalReviewData }: IProps) => {
  const [values, setValues] = useState<AdditionalSendPedigreeData>({
    poNumber: '',
    invoiceNumber: '',
    advanceShipNotice: '',
  });

  const onChange = ({ target: { id, value } }: ChangeEvent<HTMLInputElement>) =>
    setValues(prev => ({ ...prev, [id]: value }));

  useEffect(() => {
    setAdditionalData(values);
    setFinalReviewData(prev => ({ ...prev, additionalData: values }));
  }, [values]);

  return (
    <div className="card">
      <div className="card-content">
        <div className="row">
          <h6>
            Additional Information <span className="grey-text">(Optional)</span>
          </h6>
          <div className="divider" />
        </div>
        <div className="row">
          <div className="input-field col s12 m6">
            <input
              type="text"
              id="poNumber"
              value={values.poNumber}
              onChange={onChange}
            />
            <label htmlFor="poNumber">PO Number</label>
          </div>
        </div>
        <div className="row">
          <div className="input-field col s12 m6">
            <input
              type="text"
              id="invoiceNumber"
              value={values.invoiceNumber}
              onChange={onChange}
            />
            <label htmlFor="invoiceNumber">Invoice Number</label>
          </div>
        </div>
        <div className="row">
          <div className="input-field col s12 m6">
            <input
              type="text"
              id="advanceShipNotice"
              value={values.advanceShipNotice}
              onChange={onChange}
            />
            <label htmlFor="advanceShipNotice">Advance Ship Notice</label>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdditionalData;
